import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";
import { ProductDeleteResponseType } from "@sellar-io/api-v2/types";

export const useProductDelete = (productId?: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: () =>
      apiV2Request({
        user,
        business,
        method: "delete",
        path: `products/${productId}`,
      }).then(
        (data) => apiV2AssertResponse(data).data as ProductDeleteResponseType,
      ),

    onSettled: (response) => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.Products, productId],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Products],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.StockOverview],
      });
      if (response?.ParentId) {
        //sometimes we pull data from the parent, so we need to invalidate that too
        queryClient.invalidateQueries({
          queryKey: [business?.id, ServerStateKeys.Products, response.ParentId],
        });
      }
    },
  });
};
